import React from "react";
import Image from "next/image";
import { urls } from "data/links";
import Framemobile from "public/assets/champion/Framemobile.png";
import Framelaptop from "public/assets/champion/tahap.svg";
import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import {
  Wrapper,
  WrapContainer,
  WrapperContainer,
  AboutCTA,
  CardWrapper,
  CardHeading,
  CardContent
} from "./akademi-steps.styles";

export const AkademiSteps: React.FC = () => {
  const isLaptop = useMediaQuery("laptop");
  const isMobile = useMediaQuery("mobile");

  return (
    <WrapContainer>
      <Wrapper>
        {isLaptop && (
          <WrapperContainer>
            <Image src={Framelaptop} alt={"colearn power up"} />
          </WrapperContainer>
        )}
        {/* {isMobile && <Image src={Framemobile} alt={"colearn power up"} />} */}
        {isMobile && (
          <CardWrapper>
            <CardHeading>Tahap untuk bergabung:</CardHeading>
            <CardContent>
              <Image src={Framemobile} alt={"colearn power up"} />
            </CardContent>
          </CardWrapper>
        )}
        <AboutCTA href={urls.bambooHr}>Bergabunglah sekarang</AboutCTA>
      </Wrapper>
    </WrapContainer>
  );
};
